import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.neon = bracketIndenting({
	line: "#",
})
